module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-p-1600-e795d6b03073c8d790a9b132669af71a.jpg";